import { render, staticRenderFns } from "./ThingsFilter.vue?vue&type=template&id=480e6071&"
import script from "./ThingsFilter.vue?vue&type=script&lang=ts&"
export * from "./ThingsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports